var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.93 601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#727272;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.53px;}.cls-2,.cls-6{fill:#9cebff;}.cls-3,.cls-7{fill:#b7ffea;}.cls-4,.cls-5{fill:#d6d6d6;}.cls-5,.cls-6,.cls-7{stroke:#000;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.61 199.05 133.96 61.43 333.34 25.71 498 82.86 586.57 305.48 460.84 452.86 356.92 428.33 298.62 381.79 261.68 255.24 288.39 129.05 184.25 151.43 25.61 199.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "288.39 129.05 133.96 61.43 184.25 151.43 261.68 255.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.49,288.91,49.84,228.44Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "356.92 428.33 498 82.86 288.39 129.05 333.34 25.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.84,
    y1: 452.86,
    x2: 261.68,
    y2: 259.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,431.18",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "25.61 199.05 75.66 333.33 228.86 342.14 298.62 381.79 329.78 496.67 356.92 428.33 380.07 521.9 393.19 457.98 460.84 452.86 498 88.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 378.29,
    y1: 514.71,
    x2: 298.62,
    y2: 381.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.46,362.72l58.3-43.33Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "365.38 573.81 329.78 496.67 380.07 521.9 365.38 573.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "298.62 381.79 498 88.57 261.68 259.52 586.57 305.48 550.96 389.05 586.57 305.48 436.03 307.62 460.84 452.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.65,482.25l90.12-63.81Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "498 82.86 571.43 173.33 586.57 305.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "25.61 199.05 65.42 92.38 133.96 61.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.25,
    y1: 151.43,
    x2: 65.42,
    y2: 92.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "140.63 290 261.68 259.52 228.86 342.14 140.63 290"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "371.17 163.81 288.39 129.05 65.42 92.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "571.43 173.33 371.17 163.81 499.23 233.81 436.03 307.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 499.23,
    y1: 233.81,
    x2: 261.68,
    y2: 259.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 498,
    y1: 88.57,
    x2: 550.96,
    y2: 389.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "184.25 151.43 140.63 290 127.95 197.62 184.25 151.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 127.95,
    y1: 197.62,
    x2: 28.04,
    y2: 199.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "329.78 496.67 393.19 457.98 460.84 452.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.42,
    y1: 92.38,
    x2: 75.66,
    y2: 333.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "408.05 92.38 499.23 233.81 571.43 173.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 408.05,
    y1: 92.38,
    x2: 436.03,
    y2: 307.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.14,55.1,49.84,228.44,393,193.2,378.73,457.72,608.37,334.87,521,263.2,519.81,118c-18.74-2.59-364-27.14-364-27.14",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.96,
    y1: 61.43,
    x2: 408.05,
    y2: 92.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "586.57 305.48 184.25 151.43 228.86 342.14 127.95 197.62 75.66 333.33 155.32 363.1 140.63 290"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "298.62 381.79 155.32 363.1 228.86 342.14 298.62 381.79 460.84 452.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.73,457.72c6.54,1.55,194-39.28,194-39.28L457.83,337l-137.4,74.17-69.76-39.65L457.83,337",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "50.73 277.62 95.73 244.41 127.95 197.62 261.68 259.52 436.03 307.62 371.17 163.81 408.05 92.38 333.34 25.71 127.95 197.62 65.42 92.38 133.96 61.43 127.95 197.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "333.34 25.71 371.17 163.81 226.94 50.91 184.25 151.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "211.17 394.05 298.62 381.79 211.17 394.05 155.32 363.1 228.86 342.14 211.17 394.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.67,371.53",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.7,
    y1: 277.62,
    x2: 140.63,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.32,
    y1: 363.1,
    x2: 261.68,
    y2: 259.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.04 199.05 95.73 244.41 140.63 290"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 298.62,
    y1: 381.79,
    x2: 550.96,
    y2: 389.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Documents"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 152.43,
    width: 54.08,
    height: 93.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,182.82v91.24H23.8V182.82H75.88m2-2H21.8v95.24H77.88V180.82Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 472.74,
    y: 44.81,
    width: 50.51,
    height: 87.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.06,75.2v85.52H495.55V75.2h48.51m2-2H493.55v89.52h52.51V73.2Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.15,
    y: 28.62,
    width: 41.61,
    height: 65.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,59v63.62H136V59h39.61m2-2H134v67.62h43.61V57Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 566.2,
    y: 266.24,
    width: 40.72,
    height: 78.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.73,296.63V373.1H589V296.63h38.72m2-2H587V375.1h42.72V294.63Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 207.5,
    y: 226.71,
    width: 108.37,
    height: 65.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,257.1v63.62H230.3V257.1H336.67m2-2H228.3v67.62H338.67V255.1Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 171.01,
    y: 128.62,
    width: 26.48,
    height: 45.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.29,159v43.62H193.81V159h24.48m2-2H191.81v47.62h28.48V157Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 270.7,
    y: 102.9,
    width: 35.38,
    height: 52.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,133.3v50.28H293.5V133.3h33.38m2-2H291.5v54.28h37.38V131.3Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289.39,
    y: 1,
    width: 87.9,
    height: 49.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.09,31.39V78.82h-85.9V31.39h85.9m2-2h-89.9V80.82h89.9V29.39Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 424.68,
    y: 428.62,
    width: 72.32,
    height: 48.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.81,459v46.48H447.48V459h70.33m2-2H445.48v50.48h74.33V457Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 343.68,
    y: 404.81,
    width: 26.48,
    height: 47.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,435.2v45.05H366.49V435.2H391m2-2H364.49v49.05H393V433.2Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 365.93,
    y: 506.71,
    width: 28.26,
    height: 30.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,537.1v28.39H388.74V537.1H415m2-2H386.74v32.39H417V535.1Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 283.16,
    y: 356.24,
    width: 30.93,
    height: 51.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.89,386.63v49.09H306V386.63h28.93m2-2H304v53.09h32.93V384.63Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M401.87,551.3",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 125.5,
    y: 255.24,
    width: 30.26,
    height: 69.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 343.68,
    y: 134.33,
    width: 54.96,
    height: 58.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.45,164.72v57h-53v-57h53m2-2h-57v61h57v-61Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.73,
    y: 71.43,
    width: 29.37,
    height: 41.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 556.3,
    y: 143.81,
    width: 30.26,
    height: 59.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 408.55,
    y: 265.71,
    width: 54.96,
    height: 83.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 352.47,
    y: 547.62,
    width: 25.81,
    height: 52.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 316.87,
    y: 471.43,
    width: 25.81,
    height: 50.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 51.18,
    y: 305.24,
    width: 48.95,
    height: 52.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 203.16,
    y: 319.52,
    width: 51.4,
    height: 45.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 524.26,
    y: 364.76,
    width: 53.4,
    height: 48.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 463.51,
    y: 212.38,
    width: 71.43,
    height: 42.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 380.07,
    y: 71.43,
    width: 55.96,
    height: 41.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.36,
    y: 171.48,
    width: 55.19,
    height: 52.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,201.87v50.28H123.16V201.87h53.19m2-2H121.16v54.28h57.19V199.87Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.61,
    y: 266.24,
    width: 52.17,
    height: 22.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.59,296.63v20.76H49.41V296.63H99.59m2-2H47.41v24.76h54.18V294.63Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 203.16,
    y: 21.34,
    width: 47.56,
    height: 59.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 83.54,
    y: 229.29,
    width: 24.39,
    height: 30.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 140.63,
    y: 345.71,
    width: 29.37,
    height: 34.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 196.49,
    y: 376.67,
    width: 29.37,
    height: 34.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 379.95,
    y: 429.33,
    width: 26.48,
    height: 47.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,459.72v45H402.76v-45h24.48m2-2H400.76v49h28.48v-49Z",
    transform: "translate(-21.8 -29.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.11,
    y: 333.35,
    width: 66.64,
    height: 43.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.56,363.74v41.77H352.92V363.74h64.64m2-2H350.92v45.77h68.64V361.74Z",
    transform: "translate(-21.8 -29.39)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain2);
export default __webpack_public_path__ + "static/media/Brain2.d330541c40d35b3e31c44733db939296.svg";
export { ForwardRef as ReactComponent };